import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasDecimal'
})
export class HasDecimalPipe implements PipeTransform {

  transform(value: number|string): boolean {
      if (typeof value === 'string') value = parseFloat(value);
    return !Number.isInteger(value);
  }

}
